import { Box, Button, IconButton, Link, Stack, styled } from '@mui/material';

export const PanelContainer = styled(Stack)`
  position: relative;
  height: fit-content;

  &.card-panel {
    border: 1px solid var(--dk-bg, #fff);
    border-radius: 8px;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.08);
    &::before {
      content: '';
      pointer-events: none;
      position: absolute;
      border-radius: 8px;
      inset: 0;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08) inset;
      z-index: 1;
    }
  }

  &.snb-panel {
    .panel-header {
      border-color: var(--dk-line, #e7e9ec);
      background-color: var(--dk-bg, white);
      border-radius: 0;
    }
    .panel-content {
      border-radius: 0;
    }
  }
`;

export const PanelHeader = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  padding: 12px 16px 12px 8px;
  border-bottom: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 8px 8px 0 0;
  background-color: rgba(249, 250, 251, 0.9);
  z-index: 0;
`;

export const PanelContent = styled(Box)`
  background-color: var(--dk-bg, #fff);
  border-radius: 0 0 8px 8px;
  padding: 16px;
  z-index: 0;
`;

export const TitleLink = styled(Link)`
  display: flex;
  align-items: center;
  border-radius: 4px;
  text-decoration: none;
  &:hover {
    background: var(--dk-bg-muted, #f3f5f6);
    border-radius: 4px;
  }
`;

export const StyledHeaderButton = styled(Button)({
  color: 'var(--dk-text, #000)',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '18px',
  height: '18px',
  borderRadius: '4px',
  textDecoration: 'underline',
  marginRight: '-8px',
  '&:hover': {
    color: 'var(--dk-text, #000)',
    background: 'var(--dk-bg-muted, #F3F5F6)',
    textDecoration: 'underline',
  },
  '&:focus': {
    color: 'var(--dk-text, #000)',
  },
  '&.Mui-disabled': {
    color: 'var(--dk-text-secondary, #888D96)',
  },
}) as typeof Button;

export const StyledHeaderIconButton = styled(IconButton)({
  width: 'auto',
  height: 'auto',
  margin: 0,
  padding: 0,
  '&:hover': {
    background: 'var(--dk-bg-muted, #F3F5F6)',
    borderRadius: '4px',
  },
}) as typeof IconButton;
